var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"text"},[_c('div',[_vm._v("Page Not Found")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("Take Me Home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }